<template>
    <v-dialog
        v-model="visible"
        width="400px"
        @click:outside="$emit('close')"
    >
        <v-card class="overflow-hidden">
            <v-card-title>
                <span class="headline">Payment details</span>
            </v-card-title>

            <v-icon
                class="close"
                @click="$emit('close')"
            >
                mdi-close
            </v-icon>
            <v-container>
                <v-row class="fill-height overflow-auto container">
                    <!-- <v-col cols="12">
                        <div class="item-img text-center">
                            <v-avatar
                                size="150"
                                color="indigo"
                            >
                                <v-img
                                    :src="healthInsuranceEnrollee.img"
                                    height="150"
                                />
                            </v-avatar>
                            <div class="mt-3">
                                <h3>{{ healthInsuranceEnrollee.name }}</h3>
                            </div>
                        </div>
                    </v-col> -->
                    <v-col cols="12">
                        <div>
                            <h3>Information</h3>
                            <div class="description">
                                <p>{{ healthInsuranceProvider.name }}</p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="transaction_ref"
                            label="Transaction Reference Number"
                            outlined
                        />
                    </v-col>
                </v-row>
            </v-container>
            <v-card-actions>
                <v-btn
                    color="indigo"
                    class="mx-auto"
                    style="height: 43px"
                    depressed
                    dark
                    @click="save"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    /* eslint-disable camelcase */
    export default {
        props: {
            visible: Boolean,
            healthInsuranceEnrollee: {
                type: Object,
                default: () => ({}),
            },
        },
        data: () => ({
            transaction_ref: '',
        }),
        computed: {
            healthInsuranceProvider() {
                return this.healthInsuranceEnrollee.healthInsuranceProvider || {};
            },
            initiatedPayment() {
                return this.healthInsuranceEnrollee.initiatedPayment || {};
            },
        },
        methods: {
            async save() {
                try {
                    const { id } = this.initiatedPayment;
                    const { transaction_ref } = this;

                    await Vue.backendApi()
                        .healthInsurancePayments()
                        .update({
                            id,
                            transaction_ref,
                        });
                    await this.$swal({
                        type: 'success',
                        title: 'Success',
                    });
                    this.$emit('paid');
                    this.$emit('close');
                } catch (error) {
                    this.$swal({
                        type: 'error',
                        title: 'Error',
                        text: error,
                    });
                    throw error;
                }
            },
        },
    };
</script>

<style scoped>
.item-img img {
    width: 150px;
    height: 150px;
}

.close {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px;
    cursor: pointer;
}

.item-details h3 {
    color: #232323;
    font-size: 20px;
    line-height: 22px;
    font-weight: 500;
}

.item-details .title p {
    color: #232323;
    font-weight: 400;
    font-size: 18px;
    margin: 0;
}

.item-details .description {
    border-top: 1px solid #e8e8e8;
    margin: 0px 0 15px;
    display: flex;
    padding: 23px 0 0 0;
    line-height: 23px;
    font-weight: 400;
}

.item-details .description p {
    margin: 0;
    padding: 0;
}

</style>
